import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core-services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingService } from '../../landing/services/booking.service';
// import { GetRateReqBookingParameter } from 'src/app/models/GetRateReqBookingParameter';
import { RateRequestService } from 'src/app/core-services/raterequest.services';
import { BookingViewModel, PaymentDetails } from 'src/app/models/BookingViewModel';
// import { List } from 'angular-feather/icons';
import { ToastrService } from 'ngx-toastr';
import { RateRequestVM } from 'src/app/models/ReteRequest';
import 'jquery';
import * as $ from 'jquery';
import { PortService } from 'src/app/core-services/port.service';
import { RaterequestStatus } from 'src/app/Enum/Enum';

export interface CargoCondition {
  value: string;
  viewValue: string;
}
export interface BookingCharges {
  Description: string;
  Rate: number;
  Terms: string;
  Total: string;
}
declare var paypal:any;
@Component({
  selector: 'app-booking-detail',
  templateUrl: './booking-detail.component.html',
  styleUrls: ['./booking-detail.component.scss'],

})
export class BookingDetailComponent implements OnInit {
  bookingForm: FormGroup;
  RateForm: FormGroup;
  stateParams: any;
  fromCountries = [];
  toCountries = [];
  fromPort = [];
  toPort = [];
  cargoTypes = [];
  cargoSegments = [];
  cargoSegmentList = [];
  ratedropdown: any = [];
  submitted = false;
  minDate: Date;
  rageYears: string;
  currentUser: any;
  makeRaterequest: boolean = false;
  readonly: boolean = false;
  RateRequestId: number;
  shippinglineslist: any;
  RaterequestStatus: RaterequestStatus;
  offeredratelist: any;
  openPoup: boolean = false;
  descriptionLength = false;
  totalChar = 250;
  offeredamount: any;
  cargoConditions: CargoCondition[] = [
    { value: '1', viewValue: 'New' },
    { value: '2', viewValue: 'Used' }
  ]
  selected: any;
  frmport: any;
  toport: any;
  selectedCafname: any;
  selectedBAFname: any;
  selectedRatename: any;
  selectedThcname: any;
  selectedOtherchargesname: any;
  offeredRateReason: any;
  totalCount: number = 0;
  rateselected:boolean=false;
  offeredRateId:number=0;
  totalpaymentcost:number=0;
  constructor(
    private raterequestservice: RateRequestService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthService,
    private bookingService: BookingService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private portservice: PortService
  ) {
    this.raterequestservice.getRateRequestDropdown().subscribe(data => this.ratedropdown.push(...data));
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.stateParams = params.params;     
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });
  }

  ngOnInit() {
    this.createBookingForm();
    this.getCountries();
    this.getshippingline();
    this.getMasterCargoClass();
    this.getMasterCargoSegments();
    this.currentUser = JSON.parse(String(localStorage.getItem('currentUser')));
    if (this.stateParams != null && this.stateParams.fCountryId > 0 && this.stateParams.toCountryId > 0) {
      this.getPortsBycountryId(this.stateParams.fCountryId, this.stateParams.toCountryId)
    }
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
    this.readonly = true;
    this.makeRaterequest = false;
    // this.getRateRequestForBooking();
  }
  public hasError = (controlName: string, errorName: string) => {
    return this.bookingForm.controls[controlName].hasError(errorName);
  }
 
  createBookingForm() {
    this.bookingForm = this.fb.group({
      id: [''],
      fromCountry: ['', Validators.required],
      fromPort: ['', Validators.required],
      toCountry: ['', Validators.required],
      toPort: ['', Validators.required],
      cargoLanPortDate: ['', Validators.required],
      cargoClass: ['', Validators.required],
      cargoSegment: ['', Validators.required],
      cargoCondition: ['', Validators.required],
      noOfUnits: ['', [Validators.required]],
      length: ['', [Validators.required]],
      width: ['', Validators.required],
      height: ['', Validators.required],
      weight: ['', [Validators.required]],
      sqm: ['', [Validators.required]],
      cbm: ['', [Validators.required]],
      termsCondition: ['', Validators.required],
      freightrate: ['', Validators.required],
      freightratebasis: ['', Validators.required],
      othercharges: ['', Validators.required],
      otherchargesbasis: ['', Validators.required],
      baf: ['', Validators.required],
      bafbasis: ['', Validators.required],
      caf: ['', Validators.required],
      cafbasis: ['', Validators.required],
      thc: ['', Validators.required],
      thcbasis: ['', Validators.required],
      totalsumofallcost: ['', Validators.required],
      freightratevalidity: ['', Validators.required],
      ratetotal: [''],
      baftotal: [''],
      caftotal: [''],
      thctotal: [''],
      otherchargestotal: [''],
      description: ['', Validators.required],
      shippinglineId: ['', Validators.required],
    });

    this.RateForm = this.fb.group({
      noOfUnits: ['', Validators.required],
      totallanemeters: ['', Validators.required],
      totalCubicmeters: ['', Validators.required],
      freightrate: ['', Validators.required],
      freightratebasis: ['', Validators.required],
      othercharges: ['', Validators.required],
      otherchargesbasis: ['', Validators.required],
      baf: ['', Validators.required],
      bafbasis: ['', Validators.required],
      caf: ['', Validators.required],
      cafbasis: ['', Validators.required],
      thc: ['', Validators.required],
      thcbasis: ['', Validators.required],
      totalsumofallcost: ['', Validators.required],
      costperunit: ['', Validators.required],
      costpercubicmeter: ['', Validators.required],
      freightratevalidity: ['', Validators.required],
      freightratetotal: [''],
      ratetotal: [''],
      baftotal: [''],
      caftotal: [''],
      thctotal: [''],
      otherchargestotal: [''],
    });
  }

  getCountries() {
    this.spinner.show();
    this.authenticationService.getCountry().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.fromCountries = response.content;
        this.toCountries = response.content;
        if (this.stateParams != null && this.stateParams.fCountryId > 0 && this.stateParams.toCountryId > 0) {
          var selectedFromCountry = this.fromCountries.filter(x => x.id == this.stateParams.fCountryId);
          var selectedToCountry = this.toCountries.filter(x => x.id == this.stateParams.toCountryId);
          if (selectedFromCountry != null && selectedFromCountry.length > 0) {
            this.bookingForm.controls.fromCountry.setValue(selectedFromCountry[0]);
          }
          if (selectedToCountry != null && selectedToCountry.length > 0) {
            this.bookingForm.controls.toCountry.setValue(selectedToCountry[0]);
          }
        }
      }
      this.spinner.hide();
    })
  }

  getPortsBycountryId(fromCountryid, toCountryid) {
    this.spinner.show();
    this.bookingService.getPortsByTowCountryId(fromCountryid, toCountryid).
      subscribe((response: any) => {
        if (response != null && response.content != null && response.content.length > 0) {
          this.fromPort = response.content.filter(x => x.portCountryId == fromCountryid);
          this.toPort = response.content.filter(x => x.portCountryId == toCountryid);
          if (this.stateParams.fromPortId > 0 && this.stateParams.toPortId > 0) {
            var selectedFromPorts = this.fromPort.filter(x => x.id == this.stateParams.fromPortId);
            var selectedToPorts = this.toPort.filter(x => x.id == this.stateParams.toPortId);
            if (selectedFromPorts != null && selectedFromPorts.length > 0) {
              this.bookingForm.controls.fromPort.setValue(selectedFromPorts[0]);
            }
            if (selectedToPorts != null && selectedToPorts.length > 0) {
              this.bookingForm.controls.toPort.setValue(selectedToPorts[0]);
            }
          }
        }
        this.spinner.hide();
      })
  }

  onKeyPress() {
		this.descriptionLength = true;
		const charLength = this.bookingForm.controls.description.value.length;
		this.totalChar = 250 - charLength;
		if(this.totalChar === 250) {
		  this.descriptionLength = false;
		}
    }
    	  
  getMasterCargoClass() {
    this.spinner.show();
    this.bookingService.getMasterCargoClass().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        this.cargoTypes = response.content;
      }
      this.spinner.hide();
    })
  }

  getMasterCargoSegments() {
    this.spinner.show();
    this.bookingService.getMasterCargoSegments().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        this.cargoSegments = response.content;
        this.cargoSegmentList = response.content;
      }
      this.spinner.hide();
    })
  }

  getCargoSegment(event) {
    if (event != null && event != undefined) {
      if (event.value != null) {
        this.cargoSegments = this.cargoSegmentList.filter(x => x.cargoClassId == event.value.id);
        this.bookingForm.controls.cargoSegment.setValue("");
      }
    }
  }

  submitBookingForm() {
    this.submitted = true;
    this.bookingForm.controls.freightrate.setValue(0);
    this.bookingForm.controls.freightratebasis.setValue(0);
    this.bookingForm.controls.othercharges.setValue(0);
    this.bookingForm.controls.otherchargesbasis.setValue(0);
    this.bookingForm.controls.baf.setValue(0);
    this.bookingForm.controls.bafbasis.setValue(0);
    this.bookingForm.controls.caf.setValue(0);
    this.bookingForm.controls.cafbasis.setValue(0);
    this.bookingForm.controls.thc.setValue(0);
    this.bookingForm.controls.thcbasis.setValue(0);
    this.bookingForm.controls.totalsumofallcost.setValue(0);
    this.bookingForm.controls.freightratevalidity.setValue("12/12/2020");
    this.bookingForm.controls.termsCondition.setValue('dsdaf');
    if (this.bookingForm.invalid && this.submitted == true) {
      this.toastr.warning('Please Enter All The Required Fields!', 'Oops!!');
    }
    else {
      this.openPoup = true;
      let model = new RateRequestVM();
      model.FromCountryId = parseInt(this.stateParams.fCountryId);
      model.FromPortId = parseInt(this.stateParams.fromPortId);
      model.ToCountryId = parseInt(this.stateParams.toCountryId);
      model.ToPortId = parseInt(this.stateParams.toPortId);
      model.Whenportcanlanport = this.bookingForm.controls.cargoLanPortDate.value;
      model.CargoType = parseFloat(this.bookingForm.controls.cargoClass.value.id);
      model.Consigment = parseFloat(this.bookingForm.controls.cargoSegment.value.id);
      model.Condition = parseFloat(this.bookingForm.controls.cargoCondition.value.value);
      model.NoOfUnits = parseFloat(this.bookingForm.controls.noOfUnits.value);
      model.Length = parseFloat(this.bookingForm.controls.length.value);
      model.Width = parseFloat(this.bookingForm.controls.width.value);
      model.Height = parseFloat(this.bookingForm.controls.height.value);
      model.Weight = parseFloat(this.bookingForm.controls.weight.value);
      model.Sqm = parseFloat(this.bookingForm.controls.sqm.value);
      model.Cbm = parseFloat(this.bookingForm.controls.cbm.value);
      model.UserId = this.currentUser.usersDetailsVM.id;
      model.CreatedBy = this.currentUser.usersDetailsVM.userId;
      model.ShippingLineId = parseInt(this.bookingForm.controls.shippinglineId.value.shippingLineId);
      model.IsRequestFrombooking = true;
      model.transipment = this.stateParams.trashipment == 1 ? 1:0;
      model.Status = RaterequestStatus.AwaitingOffers;
      model.Cargodescription = this.bookingForm.controls.description.value;
      model.FileNames = [];
      this.spinner.show();
      this.raterequestservice.MakeRateRequest(model).subscribe((response: any) => {
        if (response != null && response.isSuccess == true && response.content != null) {
          this.raterequestservice.GetAllOfferedRatesList(response.content, "").subscribe((responseany: any) => {                   
            if(responseany != null){
              this.offeredratelist = responseany.content;
            if(responseany.content.length == 0)
            {
              this.router.navigate(['/raterequestlist']);                                  
              // this.spinner.hide(); 
              this.toastr.warning('No Offers Available, Requested For A Rate!', 'Sucess!!'); 
            }          
            if (this.openPoup && responseany.content.length != 0) {
              $("#openpoup").click();
              this.openPoup = false;
            }            
            if (this.offeredratelist != null)
              this.totalCount = this.offeredratelist.length;
          }
          })
          this.spinner.hide();                  
        }
        else {
          this.spinner.hide();
          this.toastr.warning('No Offers Available for the Request..!, Rate Has Been Requested.');
        }        
      })
      //this.spinner.hide();
    }
  }

  calculateSQM() {
    let SQM = this.bookingForm.controls.length.value * this.bookingForm.controls.width.value
      * this.bookingForm.controls.noOfUnits.value;
    this.bookingForm.controls.sqm.setValue(SQM.toFixed(2));
    this.calulateCBM();
  }

  calulateCBM() {
    let cbm = this.bookingForm.controls.length.value * this.bookingForm.controls.width.value
      * this.bookingForm.controls.height.value * this.bookingForm.controls.noOfUnits.value;
    this.bookingForm.controls.cbm.setValue(cbm.toFixed(2));
  }

  FixedNumber() {
    this.bookingForm.controls.noOfUnits.setValue(this.bookingForm.controls.noOfUnits.value.toFixed(0.00));
    this.calculateSQM();
  }

  ngAfterViewInit() {
    $(document).on('keydown', 'input[pattern]', function (e) {
      var input = $(this);
      var oldVal = input.val();
      var regex = new RegExp(input.attr('pattern'), 'g');
      setTimeout(function () {
        var newVal = input.val();
        if (!regex.test(newVal)) {
          input.val(oldVal);
        }
      }, 0);
    });
  }

  getshippingline() {
    this.portservice.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippinglineslist = response.content;
        if (this.stateParams.shippinglineId != null) {
          let selectedshipping = this.shippinglineslist.filter(x => x.shippingLineId == this.stateParams.shippinglineId);
          this.bookingForm.controls.shippinglineId.setValue(selectedshipping[0]);
        }
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  OnRateSelection() {
    var vales = this.selected;
    if (this.selected != undefined && this.selected != null && this.selected != '') {
      var selectedData = this.offeredratelist.filter(x => x.offeredRateId == this.selected);
      if (selectedData != null)
        this.getRateRequestForBooking(selectedData[0].rateRequestId, selectedData[0].offeredRateId);
      $("#closemodel").click();
      this.rateselected = true;
    }
    else
      this.toastr.warning("Please Select the Shipping Cost");
  }

  GetOfferdRate(id, frmport, toport, offerdrateId) {
    //this.closeratererequestform.nativeElement.click();
    this.spinner.show();
    this.RateForm.reset();
    this.frmport = frmport;
    this.toport = toport;
    this.raterequestservice.Getofferedratedet(id, offerdrateId).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        let newDate = new Date(response.content.freightRateValidity);
        var selectedBAF = this.ratedropdown.filter(x => x.value == response.content.rateBasisBAF);
        var selectedRate = this.ratedropdown.filter(x => x.value == response.content.rateBasisFreightRate);
        var selectedCaf = this.ratedropdown.filter(x => x.value == response.content.rateBasisCAF);
        var selectedThc = this.ratedropdown.filter(x => x.value == response.content.rateBasisTHC);
        var selectedOthercharges = this.ratedropdown.filter(x => x.value == response.content.rateBasisOtherChareges);
        this.selectedCafname = selectedCaf[0].label;
        this.selectedBAFname = selectedBAF[0].label;
        this.selectedRatename = selectedRate[0].label;
        this.selectedThcname = selectedThc[0].label;
        this.selectedOtherchargesname = selectedOthercharges[0].label;
        this.offeredRateReason = response.content.reasonForReRequest;
        this.RateForm = this.fb.group({
          noOfUnits: [response.content.totalNumberOfUnits],
          totallanemeters: [response.content.totalLandMeter],
          totalCubicmeters: [response.content.totalCubicMeter],
          freightrate: [response.content.freightRate],
          freightratebasis: [selectedRate[0].value],
          othercharges: [response.content.otherCharges],
          otherchargesbasis: [selectedOthercharges[0].value],
          baf: [response.content.baf],
          bafbasis: [selectedBAF[0].value],
          caf: [response.content.caf],
          cafbasis: [selectedCaf[0].value],
          thc: [response.content.thc],
          thcbasis: [selectedThc[0].value],
          totalsumofallcost: [response.content.totalFreightCost],
          costperunit: [response.content.costPerUnit],
          costpercubicmeter: [response.content.costPerCubicMeter],
          freightratevalidity: [newDate],
          ratetotal: [response.content.ratetotal],
          baftotal: [response.content.baftotal],
          caftotal: [response.content.caftotal],
          thctotal: [response.content.thctotal],
          otherchargestotal: [response.content.otherchargestotal]
        });
        this.offeredamount = parseFloat(response.content.totalFreightCost.toFixed(0.00));  
        this.spinner.hide();
      }
      else {
        this.toastr.error('Something went wrong!', 'Oops!!');
        this.spinner.hide();
      }
    });
  }

  getRateRequestForBooking(raterequestid, offerdrateId) {
    //  let bookingparameterreq = new GetRateReqBookingParameter();
    //  bookingparameterreq.FromCountryId = parseInt(this.stateParams.fCountryId);
    //  bookingparameterreq.FromPortId = parseInt(this.stateParams.fromPortId);
    //  bookingparameterreq.ToCountryId = parseInt(this.stateParams.toCountryId);
    //  bookingparameterreq.ToPortId = parseInt(this.stateParams.toPortId);
    // // bookingparameterreq.Status = 2;
    //  bookingparameterreq.UserId = parseInt(this.currentUser.usersDetailsVM.id);
    this.spinner.show();
    this.bookingService.GetRateRequestForBooking(raterequestid, offerdrateId).subscribe((response: any) => {
      if (response.result != null && response.result.isSuccess == true) {
        if (response.result.content != null) {
          this.readonly = true;
          this.makeRaterequest = true;
          var selectedBAF = this.ratedropdown.filter(x => x.value == response.result.content.rateBasisBAF);
          var selectedRate = this.ratedropdown.filter(x => x.value == response.result.content.rateBasisFreightRate);
          var selectedCaf = this.ratedropdown.filter(x => x.value == response.result.content.rateBasisCAF);
          var selectedThc = this.ratedropdown.filter(x => x.value == response.result.content.rateBasisTHC);
          var selectedOthercharges = this.ratedropdown.filter(x => x.value == response.result.content.rateBasisOtherChareges);
          let newDate = new Date(response.result.content.cargoLoadPortDate);
          this.bookingForm.controls.cargoLanPortDate.setValue(newDate);
          this.bookingForm.controls.noOfUnits.setValue(response.result.content.noOfUnits);
          this.bookingForm.controls.length.setValue(response.result.content.length);
          this.bookingForm.controls.width.setValue(response.result.content.width);
          this.bookingForm.controls.height.setValue(response.result.content.height);
          this.bookingForm.controls.weight.setValue(response.result.content.weight);
          this.bookingForm.controls.sqm.setValue(response.result.content.sqm);
          this.bookingForm.controls.cbm.setValue(response.result.content.cbm);
          let cargotype = this.cargoTypes.filter(x => x.id == parseInt(response.result.content.cargoType));
          let condition = this.cargoConditions.filter(x => x.value == response.result.content.condition);
          this.cargoSegments = this.cargoSegmentList.filter(x => x.cargoClassId == parseInt(response.result.content.cargoType));
          let cargosegselected = this.cargoSegments.filter(x => x.id == parseInt(response.result.content.cargoSegment));
          this.bookingForm.controls.freightrate.setValue(response.result.content.freightRate);
          this.bookingForm.controls.freightratebasis.setValue(selectedRate[0].label);
          this.bookingForm.controls.othercharges.setValue(response.result.content.otherCharges);
          this.bookingForm.controls.otherchargesbasis.setValue(selectedOthercharges[0].label);
          this.bookingForm.controls.baf.setValue(response.result.content.baf);
          this.bookingForm.controls.bafbasis.setValue(selectedBAF[0].label);
          this.bookingForm.controls.caf.setValue(response.result.content.caf);
          this.bookingForm.controls.cafbasis.setValue(selectedCaf[0].label);
          this.bookingForm.controls.thc.setValue(response.result.content.thc);
          this.bookingForm.controls.thcbasis.setValue(selectedThc[0].label);
          this.bookingForm.controls.totalsumofallcost.setValue(response.result.content.totalFreightCost);
          this.bookingForm.controls.freightratevalidity.setValue(response.result.content.freightRateValidity);
          this.bookingForm.controls.ratetotal.setValue(response.result.content.ratetotal);
          this.bookingForm.controls.baftotal.setValue(response.result.content.baftotal);
          this.bookingForm.controls.caftotal.setValue(response.result.content.caftotal);
          this.bookingForm.controls.thctotal.setValue(response.result.content.thctotal);
          this.bookingForm.controls.otherchargestotal.setValue(response.result.content.otherchargestotal);
          this.bookingForm.controls.description.setValue(response.result.content.cargopackageDescription);
          this.RateRequestId = response.result.content.rateRequestId;
          this.offeredRateId = offerdrateId;
          this.totalpaymentcost = response.result.content.totalFreightCost;
          this.bookingForm.controls.cargoCondition.setValue(condition[0]);
          this.bookingForm.controls.cargoSegment.setValue(cargosegselected[0]);
          this.bookingForm.controls.cargoClass.setValue(cargotype[0]);
        }
        else {
          this.readonly = false;
          this.makeRaterequest = false;
        }
      }
      this.spinner.hide();
    })
  }

  SaveBookingDetails()
  {   
    this.submitted = true;
      if (this.bookingForm.invalid && this.submitted == true) {            
        this.toastr.warning('Please Enter All The Required Fields!', 'Oops!!');
      }
      else {       
          if(this.bookingForm.controls.termsCondition.value == false)
          {
            this.toastr.warning('Please Agree to the Terms and Conditions!', 'Oops!!');
            return ;
          }
          else{
           // $("#openModalButton").click(); 
           // this.loadbuttons();
            this.spinner.show();
            let model = new BookingViewModel(); 
            model.FromCountryId = parseInt(this.stateParams.fCountryId);
            model.FromPortId = parseInt(this.stateParams.fromPortId);
            model.OfferedRateId = this.offeredRateId;
            model.RateRequestId = this.RateRequestId;
            model.ShippingLineId = parseInt(this.stateParams.shippinglineId);
            model.TermsAndCondition = true;
            model.ToCountryId = parseInt(this.stateParams.toCountryId);
            model.ToPortId = parseInt(this.stateParams.toPortId);
            model.VesselsId = parseInt(this.stateParams.vesselsId);
            model.VoyageId = parseInt(this.stateParams.id);  
            model.CreatedBy = this.currentUser.usersDetailsVM.userId;
            this.bookingService.SaveBookingDetails(model).subscribe((response: any) => {
                    if (response.result != null && response.result.isSuccess == true && response.result.content != null) {   
                      this.spinner.hide()
                      this.router.navigate(['/bookinglist']);                                  
                      this.toastr.success('Your booking request has been sent.', 'Awaiting booking confirmation!!');          
                    }
                    else {
                      this.spinner.hide();
                      this.toastr.error('Something went wrong!', 'Oops!!');
                    }
                });                      
          }
      }        
  }

  loadbuttons(){
    const self = this; 
    $("#openModalButton").click(); 
    this.loadExternalScript("https://www.paypal.com/sdk/js?client-id=Ac4PhNZyyz-tvi-lWEU6R8UEfId5fUCLl6y26YecV87fEeOI_EpFutelFMFi0SdZEQN5_cYOA15JObsI").then(() => {      
    paypal.Buttons({
        // env: 'sandbox',
        // client: {
        //   production: '',
        //   sandbox: 'Ac4PhNZyyz-tvi-lWEU6R8UEfId5fUCLl6y26YecV87fEeOI_EpFutelFMFi0SdZEQN5_cYOA15JObsI'
        // },
        // commit: true,
        createOrder: function(data, actions) {
          let amountval = self.totalpaymentcost;
         // This function sets up the details of the transaction, including the amount and line item details.
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: amountval
              }
            }]
          });
        },
        onApprove: function(data, actions) {
          $("#closepoup").click();
          // This function captures the funds from the transaction.
          return actions.order.capture().then(function(details) {
            // This function shows a transaction success message to your buyer.
             self.Savepaymentdetails(details);
          });
        },
        onError: function (err) {
          self.toastr.error('Something went wrong!', 'Oops!!');
          // Show an error page here, when an error occurs
        }        
      }).render('#paypal-button-container');
    });
  }

  private loadExternalScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script')
      scriptElement.src = scriptUrl
      scriptElement.onload = resolve
      document.body.appendChild(scriptElement)
  })
  }

  Savepaymentdetails(details)
  {
    this.spinner.show();
    let paymentdetails = new PaymentDetails();
    let model = new BookingViewModel(); 
    model.FromCountryId = parseInt(this.stateParams.fCountryId);
    model.FromPortId = parseInt(this.stateParams.fromPortId);
    model.OfferedRateId = this.offeredRateId;
    model.RateRequestId = this.RateRequestId;
    model.ShippingLineId = parseInt(this.stateParams.shippinglineId);
    model.TermsAndCondition = true;
    model.ToCountryId = parseInt(this.stateParams.toCountryId);
    model.ToPortId = parseInt(this.stateParams.toPortId);
    model.VesselsId = parseInt(this.stateParams.vesselsId);
    model.VoyageId = parseInt(this.stateParams.id);  
    model.CreatedBy = this.currentUser.usersDetailsVM.userId;
    //model.VesselsId = parseInt(this.stateParams.vesselsId);
    //model.VoyageId = parseInt(this.stateParams.id);
    model.CreatedBy = this.currentUser.usersDetailsVM.userId;
    paymentdetails.TransactionId = details.purchase_units[0].payments.captures[0].id;
    paymentdetails.CreatedDate= details.purchase_units[0].payments.captures[0].create_time;
    paymentdetails.Status = details.purchase_units[0].payments.captures[0].status;
    paymentdetails.AmountDebited =details.purchase_units[0].payments.captures[0].amount.value;
    paymentdetails.EmailId = details.payer.email_address;
    paymentdetails.PayerID = details.payer.payer_id;
    paymentdetails.FullName = details.purchase_units[0].shipping.name.full_name;
    paymentdetails.CreatedBy = model.CreatedBy;
    model.paymentdetails = paymentdetails; 
    this.bookingService.SaveBookingDetails(model).subscribe((response: any) => {
      if (response.result != null && response.result.isSuccess == true && response.result.content != null) {
        this.spinner.hide()
        this.router.navigate(['/bookinglist']);
        this.toastr.success('Your booking request has been sent.', 'Awaiting booking confirmation!!');
      }
      else {
        this.spinner.hide();
        this.toastr.error('Something went wrong!', 'Oops!!');
      }
    });
  }
}